module.exports = __webpack_public_path__ + "img/no.cfe9e1ea.png";